module.exports = "/_next/static/images/members-only-sticker-144a632f7329b136e855960e634dd46f.svg";